export const FONTS_SECTION_ID = "fonts";

export type SectionId =
  | typeof FONTS_SECTION_ID
  | "identity"
  | "colors"
  | "buttons"
  | "header"
  | "homepage"
  | "cards"
  | "player"
  | "spacing"
  | "css";

/** Seule « Polices » est branchée sur de vraies données pour cette v1. */
export const OPENABLE_SECTION_ID_LIST: SectionId[] = [FONTS_SECTION_ID];

interface SectionGroup {
  titleKey: string;
  sectionIdList: SectionId[];
}

export const SECTION_GROUP_LIST: SectionGroup[] = [
  {
    titleKey: "groupIdentity",
    sectionIdList: ["identity", FONTS_SECTION_ID, "colors", "buttons"],
  },
  {
    titleKey: "groupStructure",
    sectionIdList: ["header", "homepage", "cards", "player"],
  },
  { titleKey: "groupAdvanced", sectionIdList: ["spacing", "css"] },
];

export const SECTION_LABEL_KEY_BY_ID: Record<SectionId, string> = {
  identity: "sectionIdentity",
  [FONTS_SECTION_ID]: "fontsTab",
  colors: "sectionColors",
  buttons: "sectionButtons",
  header: "sectionHeader",
  homepage: "sectionHomepage",
  cards: "sectionCards",
  player: "sectionPlayer",
  spacing: "sectionSpacing",
  css: "sectionCss",
};
